import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

async function changeUserSetting(setting, value) {
    const response = await fetch('/api/set-user_setting', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
        body: JSON.stringify({
            setting: setting,
            value: value
        })
    });

    if (response.ok) {
        return true;
    } else {
        return false;
    }
}

async function deleteAccount() {
    const response = await fetch('/api/delete-account', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
    });

    if (response.ok) {
        return true;
    } else {
        return false;
    }
}

async function sendResetPasswordMail(mail) {
    const response = await fetch('/api/send-reset-password', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
        body: JSON.stringify({
            email: mail
        }) 
    });

    if (response.ok) {
        return true;
    } else {
        const errorData = await response.json();
        console.log(errorData.detail)
        return false;
    }
}

function AccountSettingsPageMain({userData}) {
    const client_version = process.env.REACT_APP_CLIENT_VERSION;

    const navigate = useNavigate();
    const [activeSection, setActiveSection] = useState('general');
    const [pressure, setPressure] = useState(userData["pressure-unit"])
    const [privacySetting, setPrivacy] = useState(userData.privacy)
    const [userDatas] = useState(userData)
    const [showAlert, setShowAlert] = useState(false)
    const [showAlertError, setShowAlertError] = useState(false)

    const [deleteAccountAlertVisibility, setDeleteAccountAlertVisibility] = useState(false) 

    const generalRef = useRef(null);
    const steamRef = useRef(null);
    const telemetryRef = useRef(null);
    const softwareRef = useRef(null);
    const privacyRef = useRef(null);

    const scrollToSection = (elementRef, sectionId) => {
        setActiveSection(sectionId);
        elementRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    };

    const handleDownload = async () => {
        window.location.assign('/downloads/LiveTelemetry.exe');
    };

    const handleDelete = async () => {
        if (await deleteAccount()) {navigate("/")}
    }

    const handleChangeSetting = async (setting, value) => {
        console.log(value)

        if (value === 1 || value === true) {
            value = "1"
        } else {
            value = "0"
        }

        await changeUserSetting(setting, value)
    }

    const handleChangePressure = async (value) => {
        await changeUserSetting("pressure-unit", value)
        setPressure(value)
    }

    const handleChangePrivacy = async (value) => {
        await changeUserSetting("privacy", value)
        setPrivacy(value)
    }

    const handleSendChangePasswordMail = async (mail) => {
        if (await sendResetPasswordMail(mail)) {
            setShowAlert(true)

            setTimeout(function () {
                setShowAlert(false)
            }, 3500)
        } else {
            setShowAlertError(true)

            setTimeout(function () {
                setShowAlertError(false)
            }, 3500)
        }
    }

    const menuItems = [
        { id: 'general', label: 'General', icon: 'person', ref: generalRef },
        { id: 'steam', label: 'Steam Integration', icon: 'sports_esports', ref: steamRef },
        { id: 'telemetry', label: 'Telemetry', icon: 'query_stats', ref: telemetryRef },
        { id: 'software', label: 'Software Client', icon: 'terminal', ref: softwareRef },
        { id: 'privacy', label: 'Privacy', icon: 'lock', ref: privacyRef },
    ];

    return (
        <>
        <main className="flex flex-1 justify-center py-8">
            <div className="layout-content-container flex max-w-[1200px] w-full px-4 md:px-10 gap-8">
                <aside className="w-0 flex-shrink-0 h-0 hidden md:h-full md:w-64 md:block">
                    <div className="flex flex-col gap-6 sticky top-24">
                        <div>
                            <h1 className="text-white text-lg font-bold font-display">Settings</h1>
                            <p className="text-[#92adc9] text-xs font-normal">Manage your racing profile</p>
                        </div>
                        <nav className="flex flex-col gap-1">
                            {menuItems.map((item) => (
                                <button
                                    key={item.id}
                                    onClick={() => scrollToSection(item.ref, item.id)}
                                    className={`flex items-center gap-3 px-3 py-2.5 rounded-lg transition-all border ${
                                        activeSection === item.id
                                            ? "bg-primary/10 text-primary border-primary/20"
                                            : "text-[#92adc9] border-transparent hover:bg-white/5 hover:text-white"
                                    }`}
                                >
                                    <span className={`material-symbols-outlined text-[22px] ${activeSection === item.id ? 'fill-1' : ''}`}>
                                        {item.icon}
                                    </span>
                                    <span className="text-sm font-medium">{item.label}</span>
                                </button>
                            ))}
                        </nav>
                    </div>
                </aside>

                <div className="flex-1 flex flex-col gap-8">
                    <div className="flex flex-col gap-2">
                        <h2 className="text-white text-2xl md:text-4xl font-black leading-tight tracking-[-0.033em] font-display">Account &amp; Telemetry Settings</h2>
                        <p className="text-[#92adc9] w-[90%] text-[13px] md:text-base">Configure your racing credentials and data synchronization preferences.</p>
                    </div>

                    <div className="bg-[#192633] border border-[#233648] rounded-xl overflow-hidden" ref={generalRef} id="general">
                        <h3 className="text-white text-lg font-bold px-6 py-4 border-b border-white/5">General Settings</h3>
                        <div className="p-6">
                            <div className="grid grid-cols-2 gap-6 mb-6">
                                <div className="flex flex-col gap-2">
                                    <label className="text-sm font-medium text-[#92adc9]">Username</label>
                                    <input className="bg-[#101922] border border-[#324d67] rounded-lg h-12 px-4 text-white focus:ring-1 focus:ring-primary focus:border-primary outline-none transition-all cursor-not-allowed" disabled type="text" defaultValue={userDatas.nickname} />
                                </div>
                                <div className="flex flex-col gap-2">
                                    <label className="text-sm font-medium text-[#92adc9]">Email Address</label>
                                    <input className="bg-[#101922] border border-[#324d67] rounded-lg h-12 px-4 text-white opacity-60 cursor-not-allowed" disabled type="email" defaultValue={userDatas.mail} />
                                </div>
                            </div>
                            <div className="flex flex-col gap-4 md:gap-0 md:flex-row items-center justify-between p-4 bg-[#101922] border border-[#324d67] rounded-lg">
                                <div>
                                    <p className="text-white font-medium">Security</p>
                                    <p className="text-[#92adc9] text-xs">Update your account password regularly to stay secure.</p>
                                </div>
                                <button onClick={() => handleSendChangePasswordMail(userDatas.mail)} className="bg-primary hover:bg-primary/80 text-white text-sm font-bold px-6 py-2 rounded-lg transition-all flex items-center gap-2">
                                    <span className="material-symbols-outlined text-[18px]">key</span>
                                    Change Password
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="bg-[#192633] border border-[#233648] rounded-xl overflow-hidden">
                        <h3 className="text-white text-lg font-bold px-6 py-4 border-b border-white/5">Two-Factor Authentication</h3>
                        <div className="p-6 flex flex-col gap-6">
                            <div className="flex items-center justify-between">
                                <div className="flex flex-col w-[70%] md:w-full">
                                    <p className="text-white font-medium">Enable Two-Factor Authentication</p>
                                    <p className="text-[#92adc9] text-sm max-w-md">Add an extra layer of security to your account by requiring a verification code in addition to your password.</p>
                                </div>
                                <label className="relative inline-flex items-center cursor-pointer">
                                    <input onChange={(e) => handleChangeSetting("two-factor-authentication", e.target.checked)} defaultChecked={userDatas["two-factor-authentication"] == "1" ? true : false} className="sr-only peer" type="checkbox" value="" />
                                    <div className="w-11 h-6 bg-[#233648] peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="bg-[#192633] border border-[#233648] rounded-xl overflow-hidden" ref={steamRef} id="steam">
                        <div className="flex items-center justify-between px-6 py-4 border-b border-white/5">
                            <h3 className="text-white text-lg font-bold">Steam Integration</h3>
                            <span className="bg-green-500/10 text-green-500 text-xs font-bold px-2 py-1 rounded flex items-center gap-1 uppercase tracking-wider">
                                <span className="material-symbols-outlined text-[14px]">check_circle</span> Linked
                            </span>
                        </div>
                        <div className="p-6 flex items-center justify-between">
                            <div className="flex items-center gap-4">
                                <div className="hidden md:block bg-[#101922] p-3 rounded-lg border border-[#324d67]">
                                    <span className="material-symbols-outlined text-primary text-3xl">sports_esports</span>
                                </div>
                                <div>
                                    <p className="text-white text-[15px] md:text-[16px] font-medium">Steam ID: 76561198283741</p>
                                    <p className="text-[#92adc9] text-[13px] md:text-text-sm">Last synchronized 4 hours ago</p>
                                </div>
                            </div>
                            <button className="bg-[#233648] hover:bg-[#324d67] text-white text-[12px] whitespace-nowrap md:text-sm font-bold px-5 py-2.5 rounded-lg transition-colors flex items-center gap-2">
                                <span className="material-symbols-outlined text-[18px]">sync</span>
                                Re-sync Account
                            </button>
                        </div>
                    </div>

                    <div className="bg-[#192633] border border-[#233648] rounded-xl overflow-hidden" ref={telemetryRef} id="telemetry">
                        <h3 className="text-white text-lg font-bold px-6 py-4 border-b border-white/5">Telemetry Preferences</h3>
                        <div className="p-6 space-y-6">
                            <div className="flex items-center justify-between">
                                <div className="flex flex-col">
                                    <p className="text-white font-medium">Enable Live Sharing</p>
                                    <p className="text-[#92adc9] text-sm">Broadcast your live telemetry to the web dashboard while racing.</p>
                                </div>
                                <label className="relative inline-flex items-center cursor-pointer">
                                    <input onChange={(e) => handleChangeSetting("live-sharing", e.target.checked)} defaultChecked={userDatas["live-sharing"] == "1" ? true : false} className="sr-only peer" type="checkbox" value="" />
                                    <div className="w-11 h-6 bg-[#233648] peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
                                </label>
                            </div>
                            <div className="flex items-center justify-between">
                                <div className="flex flex-col">
                                    <p className="text-white font-medium">Save Session History</p>
                                    <p className="text-[#92adc9] text-sm">Automatically archive your telemetry data after each session. Data will be saved for 30 days.</p>
                                </div>
                                <label className="relative inline-flex items-center cursor-pointer">
                                    <input onChange={(e) => handleChangeSetting("save-sessions", e.target.checked)} defaultChecked={userDatas["save-sessions"] == "1" ? true : false} className="sr-only peer" type="checkbox" value="" />
                                    <div className="w-11 h-6 bg-[#233648] peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
                                </label>
                            </div>
                            <div className="flex items-center justify-between pt-2">
                                <div className="flex flex-col">
                                    <p className="text-white font-medium">Default Pressure Unit</p>
                                    <p className="text-[#92adc9] text-sm">Choose between PSI and BAR for tire pressure display.</p>
                                </div>
                                <div className="flex bg-[#101922] p-1 rounded-lg border border-[#324d67]">
                                    <button onClick={() => handleChangePressure("psi")} className={`${pressure !== null ? pressure == "psi" ? "bg-primary text-white" : "text-[#92adc9] hover:text-white" : "bg-primary text-white"} px-4 py-1.5 rounded text-sm font-bold`}>PSI</button>
                                    <button onClick={() => handleChangePressure("bar")} className={`${pressure !== null ? pressure == "bar" ? "bg-primary text-white" : "text-[#92adc9] hover:text-white" : "text-[#92adc9] hover:text-white"} px-4 py-1.5 rounded text-sm font-bold`}>BAR</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="hidden md:block bg-[#192633] border border-[#233648] rounded-xl overflow-hidden" ref={softwareRef} id="software">
                        <h3 className="text-white text-lg font-bold px-6 py-4 border-b border-white/5">Local Sync Client</h3>
                        <div className="p-6">
                            <div className="flex items-start gap-6 bg-primary/5 border border-primary/20 rounded-lg p-5">
                                <div className="bg-primary/20 p-3 rounded-lg">
                                    <span className="material-symbols-outlined text-primary text-3xl">download</span>
                                </div>
                                <div className="flex-1">
                                    <div className="flex items-center justify-between">
                                        <p className="text-white font-bold text-lg">LiveTelemetry Client v{client_version}</p>
                                        <span className="text-xs bg-white/10 text-white px-2 py-0.5 rounded uppercase font-bold tracking-tighter">Current Version</span>
                                    </div>
                                    <p className="text-[#92adc9] text-sm mt-1 max-w-md">The local client bridges Assetto Corsa Competizione with our cloud platform for real-time analysis.</p>
                                    <div className="mt-4 flex gap-4">
                                        <button onClick={handleDownload} className="bg-primary hover:bg-primary/80 text-white text-sm font-bold px-6 py-2 rounded-lg transition-all shadow-lg shadow-primary/20">
                                            Download Latest Client
                                        </button>
                                        <button className="text-[#92adc9] hover:text-white text-sm font-bold underline transition-colors">
                                            Setup Guide
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="bg-[#192633] border border-[#233648] rounded-xl overflow-hidden" ref={privacyRef} id="privacy">
                        <h3 className="text-white text-lg font-bold px-6 py-4 border-b border-white/5">Privacy Control</h3>
                        <div className="p-6 flex flex-col gap-6">
                            <div className="flex flex-col gap-4">
                                <p className="text-white font-medium">Who can see your live telemetry?</p>
                                <div className="grid grid-cols-2 gap-4">
                                    <label className={`${privacySetting == "friends" ? "bg-primary/10 border-primary" : "border-[#324d67] hover:border-primary/50 transition-all"} flex items-center gap-3 p-3 md:p-4 border rounded-xl cursor-pointer`}>
                                        <input onChange={() => handleChangePrivacy("friends")} defaultChecked={privacySetting == "friends" ? true : false} className="text-primary focus:ring-primary bg-background-dark border-white/20" name="privacy" type="radio" value="friends" />
                                        <div className="flex flex-col">
                                            <span className="text-white font-bold text-sm">Friends Only</span>
                                            <span className="text-[#92adc9] text-xs">Only for followed users</span>
                                        </div>
                                    </label>
                                    <label className={`${privacySetting == "none" ? "bg-primary/10 border-primary" : "border-[#324d67] hover:border-primary/50 transition-all"} flex items-center gap-3 p-3 md:p-4 border rounded-xl cursor-pointer`}>
                                        <input onChange={() => handleChangePrivacy("none")} defaultChecked={privacySetting == "none" ? true : false} className="text-primary focus:ring-primary bg-background-dark border-white/20" name="privacy" type="radio" value="private" />
                                        <div className="flex flex-col">
                                            <span className="text-white font-bold text-sm">Private</span>
                                            <span className="text-[#92adc9] text-xs">Only visible to you</span>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="mt-8 border-t border-red-500/20 pt-8 pb-20">
                        <h3 className="text-red-500 text-lg font-bold mb-4">Danger Zone</h3>
                        <div className="flex flex-col md:flex-row gap-5 md:gap-0 items-center justify-between p-6 border border-red-500/30 rounded-xl bg-red-500/5">
                            <div>
                                <p className="text-white font-medium">Delete Account</p>
                                <p className="text-[#92adc9] text-sm">Permanently delete your profile and all telemetry history. This cannot be undone.</p>
                            </div>
                            <button onClick={() => setDeleteAccountAlertVisibility(true)} className="border border-red-500/50 text-red-500 hover:bg-red-500 hover:text-white px-5 py-2.5 rounded-lg font-bold text-sm transition-all">
                                Delete Profile
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </main>

        {deleteAccountAlertVisibility && 
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm px-4">
                <div className="w-full max-w-md bg-white dark:bg-slate-900 rounded-xl shadow-2xl border border-slate-200 dark:border-slate-800 overflow-hidden">
                    <div className="p-8 flex flex-col items-center text-center">
                        <div className="mb-6 flex items-center justify-center w-20 h-20 rounded-full bg-danger/10 text-danger">
                            <span className="material-symbols-outlined text-5xl">warning</span>
                        </div>

                        <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-4">Delete Account</h2>
                        <p className="text-slate-600 dark:text-slate-400 leading-relaxed mb-8">
                            Are you sure you want to permanently delete your account and all associated telemetry data? This action is <span className="text-danger font-semibold">irreversible</span> and cannot be undone.
                        </p>

                        <div className="flex flex-col w-full gap-3">
                            <button onClick={() => handleDelete()} className="w-full py-3 bg-danger hover:bg-danger/90 text-white font-bold rounded-lg transition-colors flex items-center justify-center gap-2">
                                <span className="material-symbols-outlined text-lg">no_accounts</span>
                                Delete My Account
                            </button>
                            <button onClick={() => setDeleteAccountAlertVisibility(false)} className="w-full py-3 bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 font-bold rounded-lg transition-colors">
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        }

        {showAlert && <span className="flex px-5 py-2 rounded-xl fixed z-[999] bg-alert-green text-sm right-[10px] top-[10px] select-none animate-[show-alert_3s_ease-in-out_forwards]">We've sent an email to {userDatas.mail}</span>}
        {showAlertError && <span className="flex px-5 py-2 rounded-xl fixed z-[999] bg-alert-red text-sm right-[10px] top-[10px] select-none animate-[show-alert_3s_ease-in-out_forwards]">Error trying to send you the mail, retry later</span>}
        </>
    );
}

export default AccountSettingsPageMain;